module.exports = __webpack_public_path__ + "48b860cb9d7027bfddc76ec3b3e8cfe3.svg";